// NOTE: do NOT re-export getStaticPaths/getStaticProps here. This module is the
// rendered page COMPONENT (client), so re-exporting the SSG functions from
// product-main drags @prisma/client into the client bundle (Turbopack errors on
// `node:module`). The page file (pages/product/[id]/[slug]/index.tsx) re-exports
// those SSG functions directly, where Next strips them from the client build.
import ProductPage from "./product-page";
export default ProductPage;
